export const profileKeys = {
	all: ["user-profile"] as const,
	detail: (id?: number | string) => [...profileKeys.all, id] as const,
};
